<template>
  <div class="mobile-order-container">
    <div class="order-row"
         v-for="(order, index) in filteredList"
         :data-index="'filteredList_'+index"
         :key="'filteredList_'+index">
      <div class="order-row-top-container">
        <div class="order-num" v-bind:data-label="$t('order')" @click="toggleModal(order)">
          #{{order.SONum}}
        </div>
        <div class="num-and-price">
          <span>{{order.TotalProducts}} {{$t('my_order_items')}}</span>
          <span>${{order.TotalPrice}}</span>
        </div>
      </div>
      <div class="order-row-bottom-container">
        <div class="order-row-bottom-left">
          <div class="order-date" v-bind:data-label="$t('delivery')" nowrap="nowrap">
            {{order.DispatchDate}}
            <!--                        {{order.TimeRange}}-->
          </div>
          <div class="order-status"
               v-if='order.SaleStatus!=="Delivered"'
               v-bind:data-label="$t('fulfillmentStatus')">
            {{curIsEnglish ? order.SaleStatus : order.SaleStatus_chinese}}
          </div>
          <div class="order-status delivered"
             v-if='order.SaleStatus==="Delivered"'
             v-bind:data-label="$t('fulfillmentStatus')">
            {{ $t('inTransit') }}
          </div>
        </div>
        <div class="order-row-bottom-right">
          <div @click="navTo(order.SalesOrder_id)"
             class="order-row-bottom-btn">
            {{ $t('view_details') }}
          </div>
          <div @click="reorder(order, $event)"
               class="order-row-bottom-btn">
            {{ $t('reorder') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {locales} from "../../mixin";

export default {
  name: "mobile-order",
  props: {
    filteredList: {
      type: Array,
      default: () => []
    }
  },
  mixins: [locales],
  methods: {
    toggleModal(order) {
      this.$emit('toggleModal', order)
    },
    navTo(SalesOrder_id) {
      this.$emit('navTo', SalesOrder_id)
    },
    reorder(order) {
      this.$emit('reorder', order)
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-order-container {
  padding-top: 16px;
  .order-row {
    width: 100%;
    height: 94px;
    padding: 16px 13px 19px 18px;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
    background-color: #FFFFFF;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .order-row-top-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .order-num {
        font-family: 'Source Sans Pro';
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #131e1e;
      }

      .num-and-price {
        font-family: 'Source Sans Pro';
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #131e1e;
        display: flex;
        align-items: center;

        span {
          &:first-child {
            margin-right: 9px;
          }
        }
      }
    }

    .order-row-bottom-container {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .order-row-bottom-left {
        display: flex;
        flex-direction: column;

        .order-date {
          font-family: 'Source Sans Pro';
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #b6b6b6;
        }

        .order-status {
          color: #fa6400;
          font-family: 'Source Sans Pro';
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
        }
      }

      .order-row-bottom-right {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .order-row-bottom-btn {
          border-radius: 11.3px;
          border: solid 0.5px #979797;
          font-family: 'Source Sans Pro';
          font-size: 12px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 16px;
          letter-spacing: normal;
          text-align: center;
          color: #979797;
          padding: 3px 10px;

          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
    .delivered {
      color: #7cc26a !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mobile-order.vue